import React from 'react';
const RestaurantSelector = ({ restaurantId, handleChangeRestaurant }) => {
  return (
    <select
      name="title"
      id="title"
      value={restaurantId}
      onChange={(e) => {
        handleChangeRestaurant(e.target.value);
      }}
    >
      <option value="1">South Lamar</option>
      <option value="2">Lakeline</option>
      <option value="3">Houston</option>
    </select>
  );
};
export default RestaurantSelector;
